import cctvCamera from "../assets/cctv-camera.webp";
import cctvLens from "../assets/cctv-lens.webp";
import cctvLight from "../assets/cctv-light1.webp";

export const cameraFeatures = [
    {
        id: "01",
        title: "CAMERA",
        description:
            "Ideali in ogni condizione metereologica e di luce, le telecamere che utilizziamo nei nostri campi ci permettono di offrirti la massima qualità al miglior prezzo. Riprendi le tue partite in qualsiasi momento con una qualità fino al 4K!",
        image: cctvCamera,
    },
    {
        id: "02",
        title: "180°\nGRADI",
        description:
            "Grazie alla doppia lente delle nostre telecamere, ogni angolo del campo è sotto controllo. Non ti perderai una singola azione della tua partita!",
        image: cctvLens,
    },
    {
        id: "03",
        title: "VISIONE\nNOTTURNA",
        description:
            "Nei campi di calciotto e calcetto, grazie ai nostri modelli AI, seguirai la partita come un vero professionista!",
        image: cctvLight,
    },
];
